import { MessagesSquare } from "lucide-react";

const parse = (text) => {
  const out = [];
  for (const line of (text || "").split("\n")) {
    const m = line.match(/^(.{1,60}?) : (.*)$/);
    const who = m ? m[1].trim() : out.at(-1)?.who || "Voix";
    const said = (m ? m[2] : line).trim();
    if (!said) continue;
    const last = out.at(-1);
    if (last && last.who === who) last.text += ` ${said}`;
    else out.push({ who, text: said, me: who !== "Contact" });
  }
  return out;
};

export const CallTranscript = ({ item }) => {
  const bubbles = parse(item.transcript);
  if (!bubbles.length) return null;
  return (
    <details className="pl-transcript" data-testid={`call-transcript-${item.call_id}`}>
      <summary data-testid={`call-transcript-toggle-${item.call_id}`}><MessagesSquare size={13} /> Voir la transcription <span className="pl-muted">({bubbles.length} échanges)</span></summary>
      <div className="pl-bubbles">
        {bubbles.map((b, i) => (
          <div key={i} className={`pl-bubble ${b.me ? "me" : "them"}`} data-testid="call-transcript-bubble">
            <small>{b.who}</small>
            <p>{b.text}</p>
          </div>
        ))}
      </div>
    </details>
  );
};
